/**
 * Checks whether the specified variable is a string.
 */
export function isString(variable: any): boolean {
    return typeof variable === 'string' || variable instanceof String
}